import * as React from "react"

import * as Scrivito from "scrivito"
import { placeholderCss } from "shared/lib/placeholderCss"

interface InPlaceEditingPlaceholderProps {
  children: React.ReactNode | React.ReactNode[]
  center?: boolean
  block?: boolean
}

export const InPlaceEditingPlaceholder = React.memo(
  ({ children, center, block }: InPlaceEditingPlaceholderProps) => {
    if (!Scrivito.isInPlaceEditingActive()) {
      return null
    }

    const innerSpan = (
      <span style={placeholderCss} data-testid="in-place-editing-placeholder">
        {children}
      </span>
    )

    if (center) {
      return <div className="text-center">{innerSpan}</div>
    }

    if (block) {
      return <div data-testid="in-place-editing-block">{innerSpan}</div>
    }

    return innerSpan
  }
)
